<template>
  <div>
    <a-drawer ref="main" :width="1200" :closable="false" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="close">
      <a-skeleton v-if="loading" active />
      <div v-else>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-descriptions size="small">
              <span slot="title">
                <span>{{ caseData.name }}</span>
                <span class="description_subtitle">#{{ caseData.key }}</span>
              </span>
            </a-descriptions>
          </a-col>
        </a-row>
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例详情</span></a-divider>
        <div class="case-detail">
          <a-descriptions :column="2" size="small">
            <a-descriptions-item label="优先级">
              <a-tag v-if="![undefined, null].includes(caseData.priority) && casePrioritys[caseData.priority]" :color="casePrioritys[caseData.priority].color"> {{ casePrioritys[caseData.priority].label }} </a-tag>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-tag v-if="caseData.status && caseStatus[caseData.status]" :color="caseStatus[caseData.status].color">
                {{ caseStatus[caseData.status].label }}
              </a-tag>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="创建人"><user-profiles v-if="caseData.creator" :value="[caseData.creator.id]" avatar /></a-descriptions-item>
            <a-descriptions-item label="最后修改人"><user-profiles v-if="caseData.modifier" :value="[caseData.modifier.id]" avatar /></a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ caseData.created_time }}</a-descriptions-item>
            <a-descriptions-item label="更新时间"> {{ caseData.updated_time }}</a-descriptions-item>
            <a-descriptions-item label="标签" :span="2">
              <a-tag v-for="(tag, index) in caseData.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
            </a-descriptions-item>
          </a-descriptions>
          <a-tabs size="small">
            <a-tab-pane key="1" tab="详细信息">
              <a-descriptions layout="vertical" :column="2">
                <a-descriptions-item label="前置条件" :span="2">
                  <span class="precondition">{{ caseData.precondition }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="操作步骤" :span="2">
                  <a-table
                    class="steps_table"
                    size="small"
                    :pagination="false"
                    :columns="columns"
                    :data-source="caseData.steps"
                    :row-key="
                      (record, index) => {
                        return index;
                      }
                    "
                  >
                    <template slot="step" slot-scope="text, record">
                      <template v-if="record.step">
                        <span v-html="record.step.replace(/\n/g, '<br>')" />
                      </template>
                      <template v-else>
                        <div style="color: lightgray; font-style: italic">操作步骤</div>
                      </template>
                    </template>
                    <template slot="result" slot-scope="text, record">
                      <template v-if="record.result">
                        <span v-html="record.result.replace(/\n/g, '<br>')" />
                      </template>
                      <template v-else>
                        <div style="color: lightgray; font-style: italic">预期结果</div>
                      </template>
                    </template>
                    <template slot="images" slot-scope="text, record">
                      <a-space>
                        <template v-for="(image, index) in record.images">
                          <a-avatar :key="index" style="cursor: pointer" shape="square" :size="56" icon="user" :src="image.url" @click="handleImageClick(image.url)" />
                        </template>
                      </a-space>
                    </template>
                  </a-table>
                </a-descriptions-item>
                <a-descriptions-item label="备注" :span="2">
                  <vditor-preview :content="caseData.description === null ? '' : caseData.description" />
                </a-descriptions-item>
              </a-descriptions>
            </a-tab-pane>
            <a-tab-pane key="2" tab="关联缺陷">
              <plan-case-issue-list :issue-list="issueData" :loading="issueListLoading" :plan-id="planId" :case-id="caseId" @change="getCaseDetail" />
              <case-issue-relation v-model="bugIdList" :bug-list="bugList" @bind-issues="bindIssues" />
            </a-tab-pane>
            <a-tab-pane key="3" tab="关联需求">
              <case-requirement :data-source="caseData.requirements" :case-id="caseId" @reload="getCaseDetail" />
              <case-requirement-relation :data-source="caseData.requirements" :case-id="caseId" @reload="getCaseDetail" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <div style="padding-top: 2px">
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例执行</span></a-divider>
        <a-descriptions :column="3" size="small">
          <a-descriptions-item label="测试结果(上次)">
            <plan-case-result-edit :disabled="true" :plan-id="planId" :case-id="caseData.id" :result="caseData.result" />
          </a-descriptions-item>
          <a-descriptions-item label="测试时间(上次)">
            <span v-if="caseData.result !== 1">{{ caseData.execTime }}</span>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="测试人员(上次)">
            <span v-if="caseData.result !== 1"><user-profiles v-if="caseData.tester" :value="[caseData.tester.id]" avatar /></span>
            <span v-else>--</span>
          </a-descriptions-item>
        </a-descriptions>
        <am-editor :content="resultComment" height="250px" @change="editorContentChange" @scroll="autoScrollToBottom" />
      </div>
      <div style="position: absolute; right: 25px; bottom: 25px">
        <a-button v-tc="{ name: '上一条' }" type="dashed" :size="size" :disabled="!hasBefore" style="margin-right: 10px" @click="onBeforeCase">
          <a-icon type="left" />
          上一条
        </a-button>
        <a-button v-tc="{ name: '下一条' }" type="dashed" :size="size" :disabled="!hasNext" style="margin-right: 10px" @click="onNextCase">
          下一条
          <a-icon type="right" />
        </a-button>
        <a-tooltip>
          <template slot="title"> 用例结果置为"通过"并加载下一条 </template>
          <a-button v-tc="{ name: '通过' }" class="pass-btn" :size="size" @click="onCasePass"> 通过 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 用例结果置为"失败"并加载下一条 </template>
          <a-button v-tc="{ name: '失败' }" class="fail-btn" :size="size" @click="onCaseFail"> 失败 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 用例结果置为"阻断"并加载下一条 </template>
          <a-button v-tc="{ name: '阻断' }" class="block-btn" :size="size" @click="onCaseBlock"> 阻断 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 用例结果置为"N/A"并加载下一条 </template>
          <a-button v-tc="{ name: 'N/A' }" type="default" :size="size" style="margin-right: 10px" @click="onCaseEmpty">
            <span style="width: 32px">N/A</span>
          </a-button>
        </a-tooltip>
        <a-button v-tc="{ name: '创建缺陷' }" type="primary" :size="size" style="margin-right: 10px" @click="onAddIssue"> 创建缺陷 </a-button>
      </div>
    </a-drawer>
    <issue-edit-modal ref="editModalRef" source-type="testplan" @ok="onOk" />
    <a-modal :visible="previewVisible" :footer="null" width="40%" height="40%" @cancel="handleModalClose">
      <img :src="modalImage" alt="" srcset="" style="width: 100%" />
    </a-modal>
  </div>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { issueList } from '@/api/project/issue';
import { hasUploadingImages } from '@/utils/utils';
import { caseUpdate, moduleList } from '@/api/project/case';
import { casePrioritys, caseStatus } from '@/utils/dictionary';
import { bindIssues, planCaseDetail, updateTestCaseResult } from '@/api/project/testPlan';

import AmEditor from '@/components/AmEditor/index';
import VditorPreview from '@/components/VditorEditor/preview';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import CaseRequirement from '@/pages/project/case/components/CaseRequirement';
import CaseIssueRelation from '@/pages/project/testplan/components/CaseIssueRelation';
import PlanCaseIssueList from '@/pages/project/testplan/components/PlanCaseIssueList';
import PlanCaseResultEdit from '@/pages/project/testplan/components/PlanCaseResultEdit';
import CaseRequirementRelation from '@/pages/project/case/components/CaseRequirementRelation';

const columns = [
  {
    title: '操作步骤',
    dataIndex: 'step',
    key: 'step',
    scopedSlots: { customRender: 'step' }
  },
  {
    title: '预期结果',
    dataIndex: 'result',
    key: 'result',
    scopedSlots: { customRender: 'result' }
  },
  {
    title: '图片',
    dataIndex: 'images',
    key: 'images',
    scopedSlots: { customRender: 'images' }
  }
];
export default {
  components: {
    AmEditor,
    VditorPreview,
    IssueEditModal,
    CaseRequirement,
    PlanCaseIssueList,
    CaseIssueRelation,
    PlanCaseResultEdit,
    CaseRequirementRelation
  },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [Number, String],
      default: null
    },
    caseId: {
      type: [Number, String],
      default: null
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      loading: true,
      visible: false,
      caseData: {
        tags: []
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      size: 'small',
      resultComment: '',
      autoLoadNextCase: false,
      moduleData: [],
      form: {
        steps: []
      },
      rules: {
        name: [{ required: true, message: '用例名称不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        module_id: [{ required: true, message: '所属目录不能为空', trigger: 'blur' }],
        precondition: [{ required: true, message: '前置条件不能为空', trigger: 'blur' }]
      },
      issueData: [],
      issueListLoading: false,
      bugIdList: [],
      bugList: {},
      previewVisible: false,
      modalImage: ''
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getTagList();
        this.getModuleList();
        if (this.caseId !== null) {
          this.getCaseDetail();
        }
      }
    },
    caseId() {
      if (this.caseId !== null) {
        this.getCaseDetail();
      }
    }
  },
  methods: {
    handleImageClick(imageUrl) {
      this.utils.trackClick({ name: '预览图片' });
      this.previewVisible = true;
      this.modalImage = imageUrl;
    },
    handleModalClose() {
      this.utils.trackClick({ name: '关闭预览' });
      this.previewVisible = false;
    },
    autoScrollToBottom() {
      var main = document.getElementsByClassName('ant-drawer-wrapper-body')[0];
      main.scrollTop = main.scrollHeight;
    },
    editorContentChange(content) {
      this.resultComment = content;
    },
    bindIssues(issueIdList) {
      bindIssues({ plan_id: this.planId, case_id: this.caseId, issues: issueIdList }).then(() => {
        this.$message.success('关联缺陷成功');
        this.getCaseDetail();
      });
    },
    // 获取缺陷列表
    getIssueList() {
      this.issueListLoading = true;
      issueList({ plan_id: this.planId, project_id: this.projectId })
        .then(res => {
          this.issueData = res.data.items;
          this.issueListLoading = false;
        })
        .catch(() => {
          this.issueListLoading = false;
        });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.caseId) {
            caseUpdate({ ...this.form, project_id: this.projectId, id: this.caseId })
              .then(() => {
                this.$message.success('用例修改成功');
                this.getCaseDetail();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    // 获取模块列表
    getModuleList() {
      moduleList({ project_id: this.projectId, return_type: 'tree' }).then(res => {
        this.moduleData = res.data.items;
      });
    },
    deleteStep(index) {
      this.form.steps.splice(index, 1);
    },

    onAddStep() {
      this.form.steps.push({ step: null, result: null });
    },

    // 数据变更的回调
    onChange(target) {
      this.$refs.form.validateField([target]);
    },
    autoLoadNextCaseChange(e) {
      this.autoLoadNextCase = e.target.checked;
    },
    // 获取用例详情
    getCaseDetail() {
      planCaseDetail({ plan_id: this.planId, case_id: this.caseId })
        .then(res => {
          this.caseData = res.data;
          this.resultComment = res.data.resultComment;
          this.form = {
            name: this.caseData.name,
            priority: this.caseData.priority,
            module_id: this.caseData.module_id,
            precondition: this.caseData.precondition,
            description: this.caseData.description ? this.caseData.description : '',
            steps: this.caseData.steps.length > 0 ? this.caseData.steps : [{ step: null, result: null }],
            tags: this.caseData.tags.map(item => {
              return item.id;
            }),
            issues: this.caseData.issues
          };
          this.issueListLoading = true;
          issueList({ project_id: this.projectId, id_list: this.caseData.issues ? this.caseData.issues : [] })
            .then(res => {
              this.issueData = res.data.items;
              this.issueListLoading = false;
              this.bugIdList = this.issueData.map(item => {
                this.$set(this.bugList, item.id, { id: item.id, key: item.key, title: item.title, status: item.status });
                return item.id;
              });
            })
            .catch(() => {
              this.issueListLoading = false;
            });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.issueData = [];
      this.$emit('close');
    },
    onAddIssue() {
      this.$refs.editModalRef.onOpen({ issueId: null, planId: this.planId, caseId: this.caseId });
    },
    onOk(issue) {
      bindIssues({ plan_id: this.planId, case_id: this.caseId, issues: [...this.caseData.issues, issue.id] }).then(() => {
        this.$message.success('创建缺陷成功');
        this.getCaseDetail();
      });
    },
    onCasePass() {
      this.updatePlanCaseResult(2, this.resultComment);
    },
    onCaseFail() {
      this.updatePlanCaseResult(3, this.resultComment);
    },
    onCaseBlock() {
      this.updatePlanCaseResult(4, this.resultComment);
    },
    onCaseEmpty() {
      this.updatePlanCaseResult(5, this.resultComment);
    },
    onNextCase() {
      this.$emit('next');
    },
    onBeforeCase() {
      this.$emit('before');
    },
    updatePlanCaseResult(result, description) {
      if (hasUploadingImages(description)) {
        this.$message.warning('有图片正在上传中，请等待上传完成或去除上传中的图片再提交哦~');
        return;
      }
      updateTestCaseResult({
        test_plan_id: this.planId,
        result: result,
        case_id: this.caseId,
        description: description
      }).then((res) => {
        this.$message.success('结果更新成功');
        this.$emit('change');

        // 检查是否返回了 result 为 true 的情况
        if (res.data && res.data.result === true) {
          this.$confirm({
            title: '提示',
            content: '当前冒烟用例已经执行完成，是否检查需求提审条件？',
            okText: '是',
            cancelText: '否',
            onOk: () => {
              // 向父组件发送检查需求提审条件的事件
              this.$emit('check-requirement-review');
            }
          });
        } else {
          // 原有的逻辑：自动跳转到下一条
          this.$emit('next');
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.case-detail {
  overflow-y: auto;
  height: calc(~'100vh - 500px');
  .precondition {
    white-space: pre-wrap;
    word-break: break-all;
  }
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0px;
}

.description_subtitle {
  margin-left: 8px;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

/deep/ .drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
  // border-bottom: 1px solid #d9d9d9;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.pass-btn {
  color: #fff;
  background-color: #87d068;
  border-color: #87d068;
  margin-right: 10px;
}

.fail-btn {
  color: #fff;
  background-color: #e95409;
  border-color: #e95409;
  margin-right: 10px;
}

.block-btn {
  color: #fff;
  background-color: #bab8b7;
  border-color: #bab8b7;
  margin-right: 10px;
}

.na-btn {
  color: #fff;
  background-color: #b24610;
  border-color: #b24610;
  margin-right: 10px;
}
</style>
